import React, { PureComponent } from 'react'

import { Route, Redirect, Switch } from 'react-router-dom'

import Dashboard from '.././Dashboard/index.jsx'
import Depository from '.././Depository/index.jsx'
import Bonus from '.././Bonus/index.jsx'
import Wallet from '.././Wallet/index.jsx'
import History from '.././History/index.jsx'
import Help from '.././Help/index.jsx'
import Settings from '.././Settings/index.jsx'
import DApp from '.././DApp/index.jsx'

export default class ComponentsRoute extends PureComponent {
    render() {
        let {
            match,
            tfaCodeRequestRequired,
            tfaType,
            exitOverdueSession,
            getStatus,
        } = this.props

        return (
            <Switch>
                <Route
                    path={`${match.url}/dashboard`}
                    render={props => (
                        <Dashboard
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
                <Route
                    path={`${match.url}/depository`}
                    render={props => (
                        <Depository
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
                {/*<Route*/}
                {/*path={`${match.url}/bonus`}*/}
                {/*render={props => (*/}
                {/*<Bonus {...props} switchSignIn={switchSignIn} />*/}
                {/*)}*/}
                {/*/>*/}
                <Route
                    path={`${match.url}/wallet`}
                    render={props => (
                        <Wallet
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
                <Route
                    path={`${match.url}/history`}
                    render={props => (
                        <History
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
                <Route
                    path={`${match.url}/help`}
                    render={props => (
                        <Help
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
                <Route
                    path={`${match.url}/settings`}
                    render={props => (
                        <Settings
                            {...props}
                            tfaCodeRequestRequired={tfaCodeRequestRequired}
                            tfaType={tfaType}
                            getStatus={getStatus}
                        />
                    )}
                />
                <Route
                    path={`${match.url}/dapp-info`}
                    render={props => (
                        <DApp
                            {...props}
                        />
                    )}
                />
                <Redirect
                    to={`${match.url}/dashboard`}
                    render={props => (
                        <Dashboard
                            {...props}
                            exitOverdueSession={exitOverdueSession}
                        />
                    )}
                />
            </Switch>
        )
    }
}
